<footer *ngIf="!hideMenu()">
	<div class="container-fluid">
		<div class="rodape">
			<div class="footer-left">
				<span class="copyright">© {{ currentYear }}. {{ 'allRightsReserved' | translate }}</span>
				<div class="separator" *ngIf="env?.termsUrl || env?.privacyUrl" aria-hidden="true"></div>
				<div class="links">
					<a *ngIf="env?.termsUrl" [href]="env.termsUrl" target="_blank">{{ 'termsAndConditions' | translate
						}}</a>
					<a *ngIf="env?.privacyUrl" [href]="env.privacyUrl" target="_blank">{{ 'privacyPolicy' | translate
						}}</a>
				</div>
			</div>
			<div class="footer-right">
				<a [href]="productInfo?.logoDestinationUrl" target="_blank">
					<img [src]="productInfo?.secondaryLogoUrl" [alt]="productInfo?.name" height="36" />
				</a>
			</div>
		</div>
	</div>
</footer>